// src/hooks/useWelcomeWizard.js
//
// P4-4 — New User Welcome Flow trigger.
//
// Yeni kullanici icin 3-adimli onboarding wizard'i ne zaman acilmali?
//
//   - users/{uid}.onboardingCompletedAt YOKsa (yeni kullanici)
//   - VE users/{uid}.interests YOKsa (legacy kullanici da yakala —
//     mevcut V3 feed InterestsPickerSheet trigger'i ile birebir esit)
//   - VE localStorage cache "done" degilse (idempotency)
//
// Auth hazir olunca BIR KEZ kontrol eder. Wizard kapanirken (saved veya
// skipped) cache'i isaretler.
//
// Returns:
//   open: boolean
//   close(): wizard kapatildi (cache isaretle)
import { useCallback, useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const CACHE_PREFIX = "mlsa.welcomeWizard.done:";

// `uid` gövdede `if (!uid)` ile korunuyor → çağıranlar boş geçebiliyor.
// Tipi `string` yazmak, kodun kendi savunmasını yalanlardı.
export default function useWelcomeWizard(uid: string | null | undefined) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!uid) {
      setOpen(false);
      return;
    }
    const key = CACHE_PREFIX + uid;
    try {
      if (typeof window !== "undefined") {
        if (window.localStorage?.getItem(key) === "done") return;
      }
    } catch (_) {}
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "users", uid));
        if (cancelled) return;
        const data = snap.exists() ? snap.data() : null;
        if (!data) return;
        const completed = !!data.onboardingCompletedAt;
        const hasInterests =
          Array.isArray(data.interests) && data.interests.length > 0;
        // Legacy: interests dolu ama marker yok -> dahil etme (kullanici
        // zaten kullaniyor, onboarding zorunlu degil). Cache'i set et.
        if (completed || hasInterests) {
          try {
            window.localStorage?.setItem(key, "done");
          } catch (_) {}
          return;
        }
        setOpen(true);
      } catch (_) {
        // permission/network -> wizard acma
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [uid]);

  const close = useCallback(() => {
    setOpen(false);
    if (!uid) return;
    try {
      if (typeof window !== "undefined") {
        window.localStorage?.setItem(CACHE_PREFIX + uid, "done");
      }
    } catch (_) {}
  }, [uid]);

  /**
   * KALICI OLMAYAN kapanış — yalnız bu oturumda gizler, `"done"` YAZMAZ.
   *
   * ── NİYE AYRI BİR KAPI (ölçülmüş karar, 2026-09-01) ────────────────────
   * Geri tuşuna "sihirbazı kapat" anlamını `close()` üzerinden vermek, kazara
   * bir jestle onboarding'i KALICI öldürmek olurdu: `close()` cache'e `"done"`
   * yazar ve sihirbaz o kullanıcıda BİR DAHA AÇILMAZ. Önceki tur geri tuşunu
   * tam bu yüzden bilerek ertelemişti ve gerekçesi hâlâ geçerli.
   *
   * İki kapı ayrıldı, çünkü bedelleri farklı:
   *   · `close()` — kullanıcı sihirbazı BİTİRDİ ya da ATLA dedi (niyet açık)
   *                 → geri alınamaz taraf meşru.
   *   · `gizle()` — kullanıcı ilk adımda GERİ bastı (niyet "buradan çık",
   *                 "bir daha gösterme" DEĞİL) → sihirbaz sonraki açılışta
   *                 yeniden doğar.
   * Kanonun ölçütü: *kapalı yönün bedeli geri alınabilir mi?* "Yanlışlıkla
   * kalıcı kapatma" geri ALINAMAZ; "sihirbaz tekrar açıldı" ALINABİLİR.
   */
  const gizle = useCallback(() => {
    setOpen(false);
  }, []);

  return { open, close, gizle };
}
